import { createCtx } from '@shared/util/context';
import { BezelProps } from './Bezel';

export type BezelCreator = (props: BezelProps) => void;

export const [useBezel, BezelContextProvider] = createCtx<BezelCreator>();
